import React, { Component } from 'react';
import { max, select, scaleBand, scaleLinear, axisTop, axisLeft } from 'd3';

import './BarChart.css';

class BarChart extends Component {

  state = {
    width: 0,
    height: 0,
    tooltip: { display: 'none', x: 0, y: 0 }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState){
    if (this.state.width !== prevState.width || this.state.height !== prevState.height) this.updateChart();
    if (this.props.data) {
      if (this.props.title !== prevProps.title) {
        this.updateDimensions();
        this.updateChart();
      }
    }
  }

  updateDimensions = () => {
    if (!this.container || !this.props.data) return;
    const { height, barHeight, data, margin } = this.props;
    const width = this.container.clientWidth;
    let newHeight = this.container.clientHeight;
    if (height) newHeight = height;
    if (barHeight) newHeight = (barHeight * data.length) + margin.top + margin.bottom;
    if (this.state.width !== width || this.state.height !== height) this.setState({ width, height: newHeight });
  }

  updateChart = () => {
    const { data, margin, color } = this.props;
    const { width, height } = this.state;
    const widthChart = width - margin.left - margin.right;
    const heightChart = height - margin.top - margin.bottom;
    const maxValue = max(data.map(item => item.value));
    const labels = data.map(item => item.key);
    const domain = this.props.domain || [0, maxValue];
    const format = this.props.format || (value => value);

    const xScale = scaleLinear().range([0, widthChart]).domain(domain);
    const yScale = scaleBand().range([0, heightChart]).domain(labels).paddingInner(0.3);

    const xAxis = axisTop(xScale);
    const yAxis = axisLeft(yScale).ticks().tickValues(labels).tickSizeOuter(0);

    const chart = select(this.container).select('.chart');

    chart.select('.x.axis').call(xAxis);
    chart.select('.y.axis').call(yAxis);
    chart.select('.baseline')
      .attr('x1', 0).attr('x2', 0)
      .attr('y1', -4.5).attr('y2', heightChart+4.5);

    const bars = chart.select('.bars').selectAll('.bar').data(data);

    bars.exit().remove();

    bars
      .enter()
        .append('rect').attr('class', 'bar')
      .merge(bars)
        .attr('fill', color.fill)
        .attr('stroke', color.stroke)
        .attr('stroke-width', 2)
        .attr('height', yScale.bandwidth())
        .attr('width', d => xScale(d.value))
        .attr('x', 0)
        .attr('y', d => yScale(d.key));


    const catchers = chart.select('.catchers').selectAll('.catcher').data(data);

    catchers.exit().remove();

    catchers
      .enter()
        .append('rect').attr('class', 'catcher')
      .merge(catchers)
        .attr('fill', '#fff')
        .attr('stroke', '#fff')
        .attr('height', heightChart/labels.length)
        .attr('width', widthChart)
        .attr('x', 0)
        .attr('y', d => yScale(d.key))
        .style('opacity', 0)
      .on('mouseover', d => {
          this.setState( {
            tooltip: {
              display: 'block',
              x: xScale(d.value) + margin.left + 12,
              y: yScale(d.key) + yScale.bandwidth(),
              text: format(d.value)
            }
          })
        })
      .on('mouseleave', () => {
          this.setState( {
            tooltip: {
              display: 'none',
              x: 0,
              y: 0,
              text: ''
            }
          })
      });


  }

  render() {
    const { width, height } = this.state;
    const { margin } = this.props;
    const { display, x, y, text } = this.state.tooltip;

    const containerStyle = {
      position: 'relative'
    }
    const tooltipStyle = {
      display: display,
      position: 'absolute',
      left: x,
      top: y
    }

    return (
      <div className="BarChart" ref={container => this.container = container} style={containerStyle}>
        <svg
          width={width}
          height={height} >
          <g className="chart" transform={"translate(" + margin.left + "," + margin.top + ")"}>
            <g className="bars" />
            <g className="catchers" />
            <g className="x axis"></g>
            <g className="y axis"></g>
            <line className="baseline" />
          </g>
        </svg>
        <div className="tooltip" style={tooltipStyle}><span>{text}</span></div>

      </div>
    );
  }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/BarChart/BarChart.js